import { API_ENDPOINTS } from '../config/api';

/**
 * Fetch all bookings from the backend
 * @param {boolean} includeDetails - Whether to include passengers and tickets
 */
export const fetchAllBookings = async (includeDetails = false) => {
  try {
    const url = includeDetails 
      ? `${API_ENDPOINTS.BOOKINGS}?includeDetails=true`
      : API_ENDPOINTS.BOOKINGS;
    
    const response = await fetch(url, {
      credentials: 'include', // Include cookies for authentication
    });
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch bookings');
    }
    
    return data.data || [];
  } catch (error) {
    console.error('Error fetching bookings:', error);
    throw error;
  }
};

/**
 * Fetch booking details by reference (includes passengers and tickets)
 */
export const fetchBookingDetails = async (reference) => {
  try {
    const response = await fetch(`${API_ENDPOINTS.BOOKINGS}/${reference}`, {
      credentials: 'include', // Include cookies for authentication
    });
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch booking details');
    }
    
    return data.data;
  } catch (error) {
    console.error('Error fetching booking details:', error);
    throw error;
  }
};

/**
 * Update booking status
 */
export const updateBookingStatus = async (reference, status) => {
  try {
    const response = await fetch(API_ENDPOINTS.UPDATE_STATUS(reference), {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Include cookies for authentication
      body: JSON.stringify({ status }),
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to update booking status');
    }
    
    return data.data;
  } catch (error) {
    console.error('Error updating booking status:', error);
    throw error;
  }
};

/**
 * Update payment status
 */
export const updatePaymentStatus = async (reference, payment_status) => {
  try {
    const response = await fetch(API_ENDPOINTS.UPDATE_PAYMENT_STATUS(reference), {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Include cookies for authentication
      body: JSON.stringify({ payment_status }),
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to update payment status');
    }
    
    return data.data;
  } catch (error) {
    console.error('Error updating payment status:', error);
    throw error;
  }
};

/**
 * Delete a booking by reference
 */
export const deleteBooking = async (reference) => {
  try {
    const response = await fetch(`${API_ENDPOINTS.BOOKINGS}/${reference}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Include cookies for authentication
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Failed to delete booking');
    }
    
    return data.data;
  } catch (error) {
    console.error('Error deleting booking:', error);
    throw error;
  }
};
